import PrimaryBtn from "../UI/PrimaryBtn";
import styles from "./InfoSecondary.module.css";
import infoImg from "../../assets/images/info-2-bg.png";

const InfoSecondary = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>play on the best turf</h2>
        <div className={styles.contentContainer}>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
        </div>
        <PrimaryBtn className={styles.btn}>Know More</PrimaryBtn>
      </div>
      <img className={styles.img} src={infoImg} alt="Football Ground" />
    </section>
  );
};

export default InfoSecondary;
